import React, { Component } from "react";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { reduxForm, Form, Field } from "redux-form";

import { SYSTEM_VERSION } from "../../../../../config/consts";

import {
	setFormValue,
	create_or_update
} from "../../../../../helpers/formComponent";
import { setLoading } from "../../../../../helpers/redux";

import {
	ContentHeader,
	Content
} from "../../../../../common/components/layout";
import Card from "../../../../../common/components/ui/card/card";
import Button from "../../../../../common/components/ui/button/button";

import { getListAll as getAllUsers } from '../../users/usersActions';
import types from "../usersTypes";
import fields from "./fields";
import { getDetail, setDetail, create, update } from "../usersActions";
import { getListAll as getAllRules } from "../../rules/rulesActions";

export class UsersForm extends Component {
	constructor(props) {
		super(props);
		this.props.getAllUsers();
		this.props.getAllRules();
		const {
			users, router, location, getDetail, setDetail, setLoading
		} = this.props;

		setLoading(types.USERS_LOADING, true);
		setFormValue(users, router, location, getDetail, setDetail);
	}

	onSubmit = values => {
		const { router, create, update } = this.props;
		const newValues = {
			...values, 
			active:values.active.value,
			rules: [values.rules.value]
		}

		create_or_update(router, newValues, create, update);
	};

	renderRules = () => {
		return this.props.rules.list.content.map((item) => ({
			label: item.name,
			value: item._id,
			item: item
		}))
	}

	renderFields = () => {
		return fields(this.renderRules).map((item, index) => (
			<Field {...item} key={index} />
		));
	};

	render() {
		const { handleSubmit } = this.props;
		return (
			<div>
				<ContentHeader
					title="Usuários"
					small={`Versão ${SYSTEM_VERSION}`}
				/>
				<Content>
					<Card header title="Formulário">
						<Form
							role="form"
							onSubmit={handleSubmit(this.onSubmit)}
							noValidate
						>
							<div className="form__body">
								{this.renderFields()}
							</div>
							<div className="form__footer">
								<div className="form__footer--actions">
									<Button
										text="Cancelar"
										type="button"
										rounded
										colors={"#f1c40f"}
										textStyle={{ color: "#555" }}
										outline
										onClick={() =>
											this.props.router.goBack()
										}
									/>
									<Button
										text="Salvar"
										type="submit"
										// style={{ width: "25%" }}
										rounded
										buttonType="primary"
										textStyle={{ color: "#555" }}
										outline
										// animated
									/>
								</div>
							</div>
						</Form>
					</Card>
				</Content>
			</div>
		);
	}
}

UsersForm = reduxForm({ form: "usersForm" })(UsersForm);

const mapStateToProps = state => {
	return {
		users: state.users,
		rules: state.rules,
	};
};

const mapDispatchToProps = dispatch => ({
	...bindActionCreators(
		{
			getDetail,
			setDetail,
			create,
			update,
			setLoading,
			getAllUsers,
			getAllRules
		},
		dispatch
	)
});

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(UsersForm);
